import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import Stack from "@mui/material/Stack";
import Alert from "@mui/material/Alert";
import Typography from "@mui/material/Typography";
import CloseIcon from "@mui/icons-material/Close";
import MDButton from "components/MDButton";
import { modalHeaderSx, modalPaperSx } from "../../components/contas-financeiras.theme";
import type { ContaFinanceiraGerencialApi } from "../types/contas-financeiras.types";

export type ExcluirContaFinanceiraDialogState = {
  open: boolean;
  conta: ContaFinanceiraGerencialApi | null;
};

type Props = {
  state: ExcluirContaFinanceiraDialogState;
  loading: boolean;
  error: string | null;
  onClose: () => void;
  onConfirm: () => void;
};

export default function ExcluirContaFinanceiraDialog({
  state,
  loading,
  error,
  onClose,
  onConfirm,
}: Props) {
  const nome = state.conta?.nome ?? "";

  return (
    <Dialog
      open={state.open}
      onClose={loading ? undefined : onClose}
      maxWidth={false}
      fullWidth
      PaperProps={{ sx: { ...modalPaperSx, maxWidth: 420 } }}
      aria-labelledby="excluir-conta-financeira-title"
    >
      <Box sx={modalHeaderSx}>
        <Stack direction="row" alignItems="flex-start" justifyContent="space-between">
          <Box>
            <Typography variant="overline" sx={{ opacity: 0.75, letterSpacing: 1.2 }}>
              Exclusão
            </Typography>
            <Typography id="excluir-conta-financeira-title" variant="h5" fontWeight="bold">
              Excluir conta
            </Typography>
          </Box>
          <IconButton onClick={onClose} sx={{ color: "inherit" }} aria-label="Fechar" disabled={loading}>
            <CloseIcon />
          </IconButton>
        </Stack>
      </Box>
      <DialogContent sx={{ p: 3 }}>
        {error ? (
          <Alert severity="error" sx={{ mb: 2 }}>
            {error}
          </Alert>
        ) : null}
        <Alert severity="warning" sx={{ mb: 2 }}>
          Esta ação remove a conta permanentemente. Não é possível desfazer.
        </Alert>
        <Typography variant="body2">
          Confirma a exclusão de <strong>{nome}</strong>?
        </Typography>
      </DialogContent>
      <DialogActions sx={{ px: 3, py: 2, borderTop: "1px solid", borderColor: "grey.200" }}>
        <MDButton variant="outlined" color="dark" onClick={onClose} disabled={loading}>
          Cancelar
        </MDButton>
        <MDButton
          variant="gradient"
          color="error"
          onClick={onConfirm}
          disabled={loading}
        >
          {loading ? "Excluindo…" : "Excluir"}
        </MDButton>
      </DialogActions>
    </Dialog>
  );
}
